import React, {Component} from 'react';
import {Platform, StyleSheet, Text, View, ScrollView, TouchableOpacity, FlatList, I18nManager,} from 'react-native';

import Colors from "../tools/Colors";
import {moderateScale} from "../tools/Scaling";
import HMTextView from "./HMTextView";
import HMTextInput from "./HMTextInput";
import i18n from "../I18n/i18n";
import EmptyView from "../customviews/empty/EmptyView";
import HMIcon from "./HMIcon";
import HMModal from "./modal/HMModal";


export default class HMModalSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataSourceSub: []
        }
    }

    render() {
        const {dataSourceSub} = this.state;
        const {autoFocus, style, text, icon, navigateParams, visibleModal, hiddenModal, SearchFilterFunction, textInput, dataSource, onChangeItem} = this.props;


        return (
            <HMModal
                isVisible={visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => {
                    this.setState(
                        {
                            // ShowAudio:f,
                            dataSourceSub: [],

                        }
                    )
                    hiddenModal?.();
                }}
                onBackButtonPress={() => {
                    this.setState(
                        {
                            // ShowAudio:f,
                            dataSourceSub: [],

                        }
                    )
                    hiddenModal?.();
                }}
            >

                <View style={{height: "85%", backgroundColor: Colors.white}}>
                    <TouchableOpacity
                        // onPress={this.onShowCity()}
                        style={{
                            flexDirection: 'row',
                            borderRadius: moderateScale(6),
                            borderWidth: moderateScale(1),
                            borderColor: '#ececec',
                            backgroundColor: Colors.light,
                            height: moderateScale(38),
                            width: '95%',
                            //  flex:1,
                            marginVertical: moderateScale(8),
                            // marginHorizontal: moderateScale(8),
                            alignSelf: 'center',
                            alignItems: 'center',
                            //  justifyContent: 'flex-end',
                            paddingHorizontal: moderateScale(4)
                        }}>
                        <View style={{flex: .9}}>
                            <HMTextInput value={textInput}
                                //keyboardType="numeric"
                                         _backgroundColor={Colors.transparent}
                                         onChangeText={SearchFilterFunction}
                                         autoFocus={autoFocus}
                                         placeholder={i18n.t('constant.filter')}
                                         NoShowPlaceholder
                                //_width={'90%'}
                                // icon={"md-person"}
                                         text={''}
                                         style={{
                                             fontSize: moderateScale(14),


                                             // marginTop: moderateScale(6)
                                         }} underlineColorAndroid="transparent" maxLength={11}/>
                        </View>
                        {/*<HMTextView text={i18n.t('constant.filter')}*/}
                        {/*style={{*/}
                        {/*fontSize: moderateScale(16),*/}
                        {/*//textAlign: 'right'*/}
                        {/*}}/>*/}
                        {/*<View style={{flex:1}}/>*/}

                        <View style={{flex: .1, alignItems: 'center', justifyContent: 'center'}}>
                            <HMIcon name={"md-search"} style={{fontSize: moderateScale(22), color: Colors.colorDark}}/>
                        </View>

                    </TouchableOpacity>


                    {
                        (dataSourceSub && dataSourceSub.length > 0) ?
                            <TouchableOpacity
                                style={{

                                    //    marginHorizontal: moderateScale(10),
                                    width: moderateScale(48),
                                    //  height: moderateScale(48),
                                    alignSelf: "end",

                                    justifyContent: 'center',
                                    alignItems: 'center',

                                    marginTop: moderateScale(4)
                                    // bottom:0,
                                }}

                                onPress={
                                    () => {
                                        this.setState(
                                            {
                                                // ShowAudio:f,
                                                dataSourceSub: [],

                                            }
                                        )
                                    }

                                }>
                                <View style={{
                                    //  flexDirection:Rtl ? 'row-reverse': 'row',
                                    flexDirection: 'row',
                                    alignItems: "flex-end",
                                    //marginHorizontal: moderateScale(4)
                                }}>
                                    <HMIcon name={
                                        //Rtl ? "ios-arrow-back":'ios-arrow-forward'
                                        I18nManager.isRTL ? "ios-arrow-back" : 'ios-arrow-forward'
                                        // 'ios-arrow-back'

                                    }
                                            style={{fontSize: moderateScale(26), color: Colors.gray}}/>
                                    {/*<HMTextView text={i18n.t('constant.Back')}*/}
                                    {/*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*/}
                                </View>
                            </TouchableOpacity>
                            :
                            null
                    }
                    {
                        (dataSourceSub && dataSourceSub.length > 0) || (dataSource && dataSource.length > 0) ?
                            <FlatList
                                style={{
                                    //backgroundColor: Colors.white

                                }}
                                // data={this.state.arrayCity}
                                data={(dataSourceSub && dataSourceSub.length > 0) ? dataSourceSub : dataSource}
                                renderItem={({item, index, separators}) => (
                                    <TouchableOpacity
                                        style={{padding: moderateScale(10), marginHorizontal: moderateScale(10)}}
                                        onPress={
                                            //  onChangeItem(item,index)
                                            () => {
                                                if ((item.subjects && item.subjects.length > 0) || (item.places && item.places.length > 0)) {
                                                    this.setState({dataSourceSub: item.subjects ? item.subjects : item.places})
                                                }
                                                else {
                                                    this.setState(
                                                        {
                                                            // ShowAudio:f,
                                                            dataSourceSub: [],

                                                        }
                                                    )
                                                    onChangeItem(index, item)

                                                }
                                            }
                                        }>
                                        <View style={{
                                            flexDirection: "row",
                                            //justifyContent: "space-between",
                                            alignItems: "center"
                                        }}>
                                            {/*<HMIcon name="ios-arrow-back" color="#000" size={moderateScale(20)}/>*/}
                                            {/*<View style={{*/}

                                            {/*width: moderateScale(32),*/}
                                            {/*height: moderateScale(32),*/}

                                            {/*}}>*/}

                                            {/*/!*      <HMSvgView*/}
                                            {/*uriComplete={"https://image.flaticon.com/icons/svg/1357/1357862.svg"}*/}
                                            {/*//  uriComplete={item.image}*/}
                                            {/*// uriComplete={item.svg}*/}
                                            {/*//    indexParent={this.state.currentPage}*/}
                                            {/*/>*!/*/}
                                            {/*/!*    <HMImageView*/}
                                            {/*uriComplete={item.image}*/}
                                            {/*//   styleText={{marginTop: moderateScale(10)}}*/}
                                            {/*//  styleShadoBackground={{borderRadius: moderateScale(7)}}*/}
                                            {/*/>*!/*/}
                                            {/*</View>*/}
                                            <View style={{width: moderateScale(6)}}/>
                                            <HMTextView
                                                noFont
                                                type={"bold"}
                                                text={item.name ? item.name : (item.subjects_tks_subject ? item.subjects_tks_subject : "")}
                                                style={{
                                                    color: Colors.blackLight,
                                                    flex: 1,
                                                    fontSize: moderateScale(12),

                                                    //  marginEnd: moderateScale(10)
                                                }}/>
                                        </View>
                                    </TouchableOpacity>

                                )}
                                keyExtractor={(item, index) => item.id + index}
                                // ItemSeparatorComponent={this.renderSeparator}
                                enableEmptySections={true}
                            />
                            :

                            <EmptyView empty height={moderateScale(200)}/>


                    }

                </View>
            </HMModal>
        );
    }

    onChangeFlatlist() {

    }
}
